
































































import { TypeMap, Expression, MethodExpression, NoExpression, Func, Entity } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';
import { getTestFunction } from '../../../app/TestFunction';
import { getEditFunction } from '../../../app/EditFunction';


export default ExpressionBase<MethodExpression>().extend({
  name: 'MethodEditor',
  data: () => ({
    hiddenParams: {} as Record<string, boolean>,
  }),
  computed: {
    entity(): Entity | null {
      return this.registry.defs.getEntity(this.value.entity);
    },
    func(): Func | null {
      return this.entity 
        ? this.entity.methods[this.value.name]
        : null;
    },
    paramTypes(): TypeMap {
      return this.func
        ? this.func.params.options.props
        : {};
    },
  },
  methods: {
    toggleParameter(name: string) {
      if (name in this.hiddenParams) {
        this.$delete(this.hiddenParams, name);
      } else {
        this.$set(this.hiddenParams, name, true);
      }
    },
    hiddenParameter(name: string) {
      return !!this.hiddenParams[name];
    },
    isExtraArgument(name: string) {
      return !this.paramTypes[name];
    },
    getParam(param: string) {
      return this.value.args[param] || NoExpression.instance;
    },
    setParam(param: string, expr?: Expression) {
      this.$set(this.value.args, param, expr || NoExpression.instance);
      this.update();
    },
    removeParam(param: string) {
      this.$delete(this.value.args, param);
      this.update();
    },
    test() {
      const registry = this.registry;
      const name = this.value.name;

      getTestFunction({ registry, name });
    },
    edit() {
      const registry = this.registry;
      const name = this.value.name;

      getEditFunction({ registry, name });
    },
  },
});
